module.exports = __webpack_public_path__ + "images/emoji/ferris_wheel.5dfde3b9d7a42b13308e.png";